/**
 * Shared keyboard behavior for filter strips (Reporting, Export, Workflows, etc.):
 * - Date inputs: picker-led entry without trapping Tab (avoid `onkeydown="return false"`).
 * - Native-like selects: Backspace clears selection back to empty placeholder value.
 */

export function pickerOnlyDateFieldKeydown(e: KeyboardEvent): void {
  const k = e.key;
  if (
    k === "Tab" ||
    k === "Escape" ||
    k === "Enter" ||
    k.startsWith("Arrow") ||
    k === "Home" ||
    k === "End" ||
    k === "PageUp" ||
    k === "PageDown" ||
    e.ctrlKey ||
    e.metaKey ||
    e.altKey
  ) {
    return;
  }
  e.preventDefault();
}

export type SelectBackspaceClearOptions = {
  /** Bound select value; empty means nothing to clear */
  value: string;
  /** When true, Backspace does nothing (e.g. Business Unit locked for BU admin) */
  locked?: boolean;
  onClear: () => void;
};

/** Clears a filter dropdown via Backspace when focused (matches audit-reporting UX). */
export function filterSelectBackspaceClearKeydown(
  e: KeyboardEvent,
  opts: SelectBackspaceClearOptions,
): void {
  if (e.key !== "Backspace") return;
  if (opts.locked) return;
  if (!opts.value) return;
  e.preventDefault();
  opts.onClear();
}
